<header class="page-top"
        [class.page-top--dark]="screenService.down('tablet')"
        [class.sidebar--active]="storeService.sidebar">
  <burger-menu class="page-top__burger-menu"
               [active]="storeService.sidebar"
               (changeState)="toggleSidebar()">
  </burger-menu>
  <div class="position-relative" dropdown placement="bottom right">
    <button id="button-profile"
            type="button"
            class="page-top__profile-btn dropdown-toggle"
            dropdownToggle
            aria-controls="dropdown-profile">
      <span class="page-top__avatar avatar avatar--default mr-2">
        {{ storeService.user?.firstName.slice(0, 1) }}
      </span>
      <span class="page-top__name mr-2">
        {{ storeService.user?.firstName }} {{ storeService.user?.secondName.slice(0, 1) }}
      </span>
    </button>

    <profile-top id="dropdown-profile"></profile-top>
  </div>
</header>
